document.addEventListener('DOMContentLoaded', function () {
  // Helper functions
  function show(el) {
    if (!el) return;
    el.classList.remove('disable-hide');
    el.classList.add('enable-show');
    enableInputs(el);
  }

  function hide(el) {
    if (!el) return;
    el.classList.remove('enable-show');
    el.classList.add('disable-hide');
    disableInputs(el);
  }

  function toggle(el, condition) {
    condition ? show(el) : hide(el);
  }

  // Enable/disable all inputs/selects inside an element
  function enableInputs(el) {
    el.querySelectorAll('input, select, textarea, button').forEach(input => {
      input.disabled = false;
    });
  }

  function disableInputs(el) {
    el.querySelectorAll('input, select, textarea, button').forEach(input => {
      input.disabled = true;
      // auto uncheck radios/checkboxes when disabled
      if (input.type === 'checkbox' || input.type === 'radio') {
        input.checked = false;
      }
    });
  }

  // === Elements ===
  const certSelect = document.getElementById('type_of_certification');
  const fiber = document.getElementById('fiber');
  const copper = document.getElementById('copper');
  const fusion = document.getElementById('fusion');
  const copperCords = document.getElementById('copper-cords');
  const dsxPc = document.getElementById('dsx-pc');
  const ethernetCabling = document.getElementById('ethernet-cabling');
  const dsxCha = document.getElementById('dsx-cha');
  const defaultImg = document.querySelector('.default-img');
  const copperImg = document.getElementById('copper-img');
  const coaxImg = document.getElementById('img-coax-yes');
  const checkFiberTrouble = document.getElementById('check_fiber_trouble');
  const checkOpticalLoss = document.getElementById('check_optical_loss');
  const showCables = document.getElementById('show-cables');
  const fusionRibbon = document.getElementById('fusionribbon');
  const fusionSingle = document.getElementById('fusionsingle');
  const fiberCertificationImgBlock = document.getElementById('fiber-certification-default-img');
  const fiberDefaultImg = document.getElementById('fiber-default-img');
  const bothConnectorCableYes = document.getElementById('both-connector-cable-yes');
  const hideConnectorNo = document.getElementById('hide-connector-no');
  const showCableNoAndConnectorYes = document.getElementById('show-cable-no-and-connector-yes');
  const showCableYes = document.getElementById('show-cable-yes');
  const showCableYes2 = document.getElementById('show-cable-yes-2');
  const DSXPC5ES = document.getElementById('DSX-PC5ES');
  const DSXPC6S = document.getElementById('DSX-PC6S');
  const DSXPC6AS = document.getElementById('DSX-PC6AS');
  const DSXCHA021S = document.getElementById('DSX-CHA021S');
  const DSXCHAM12XS = document.getElementById('DSX-CHA-M12-X-S');
  const showCopperFiberCerti = document.getElementById('show-copper-fiber-certi');
  const fiberCopperOLTS = document.getElementById('fiber_copper_OLTS ');
  const fiberCopperOTDR = document.getElementById('fiber_copper_OTDR');

  const checkSpliceCopperRadios = document.querySelectorAll('.check_splice_copper');
  const checkPatchCopperRadios = document.querySelectorAll('.check_patch_cords');
  const checkEthernetCablingRadios = document.querySelectorAll('.check_ethernet_cabling');

  const copperCertificationDefault = document.querySelectorAll('.copper-certification-default');
  const fiberCopperBothNo = document.querySelectorAll('.fiber_copper_both_no');

  // Fusion splicer items
  const items = [
    { checkbox: document.querySelector('input#fujikura-70r'), image: document.getElementById('fusion-r-1') },
    { checkbox: document.querySelector('input#fiber-fox-mini-12r'), image: document.getElementById('fusion-r-2') },
    { checkbox: document.querySelector('input#fujikura-70s'), image: document.getElementById('fusion-s-1') },
    { checkbox: document.querySelector('input#fiber-fox-mini-6s'), image: document.getElementById('fusion-s-2') }
  ];

  // === Fusion helper ===
  function hideAllImages() {
    items.forEach(item => {
      hide(item.image);
      if (item.checkbox) item.checkbox.checked = false;
    });
  }

  // === RESET FUNCTION ===
  function resetAll() {
    // Hide all sections
    [
      fiber, copper, fusion, copperCords, dsxPc, ethernetCabling, dsxCha,
      defaultImg, copperImg, coaxImg, showCables, fusionRibbon, fusionSingle,
      fiberCertificationImgBlock, fiberDefaultImg, bothConnectorCableYes,
      hideConnectorNo, showCableNoAndConnectorYes, showCableYes, showCableYes2,
      DSXPC5ES, DSXPC6S, DSXPC6AS, DSXCHA021S, DSXCHAM12XS, showCopperFiberCerti, 
    ].forEach(hide);

    // Hide fusion images + uncheck
    hideAllImages();

    // Uncheck radios/checkboxes
    document.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(input => {
      input.checked = false;
    });

    // Reset selects (except certification select)
    document.querySelectorAll('select').forEach(select => {
      if (select.id !== 'type_of_certification') {
        select.selectedIndex = 0;
      }
    });
  }

  function updateCopperFiberDefaults() {
    const fiberVal = checkFiberTrouble?.value || '';
    const opticalVal = checkOpticalLoss?.value || '';

    // Only apply this rule when Copper & Fiber Certification is selected
    if (certSelect.value === 'Copper & Fiber Certification') {
        if (fiberVal === '' || opticalVal === '') {
          copperCertificationDefault.forEach(el => hide(el));
          hide(showCopperFiberCerti);
          hide(fiberDefaultImg);
          show(defaultImg);

        } else if (fiberVal === 'Yes' && opticalVal === 'Yes') {
          copperCertificationDefault.forEach(el => show(el));
          show(showCopperFiberCerti);
          hide(defaultImg);
          show(fiberCopperOLTS);
          show(fiber_copper_OTDR);

        } else if (fiberVal === 'Yes' && opticalVal === 'No') {
          copperCertificationDefault.forEach(el => show(el));
          show(showCopperFiberCerti);
          show(fiber_copper_OTDR);
          hide(fiberCopperOLTS);
          hide(defaultImg);
        }else if (fiberVal === 'No' && opticalVal === 'Yes') {
          copperCertificationDefault.forEach(el => show(el));
          show(showCopperFiberCerti);
          show(fiberCopperOLTS);
          hide(fiber_copper_OTDR);
          hide(defaultImg);
        }else if (fiberVal === 'No' && opticalVal === 'No') {
          copperCertificationDefault.forEach(el => show(el));
          fiberCopperBothNo.forEach(el => hide(el));
          hide(fiberCopperOLTS);
          hide(fiber_copper_OTDR);
          hide(defaultImg);
        }else {
          copperCertificationDefault.forEach(el => show(el));
          show(showCopperFiberCerti);
          hide(defaultImg);
        }
      }
  }

  // === Certification select logic ===
  certSelect.addEventListener('change', function () {
    resetAll(); // 🧹 reset everything first
    const val = this.value;

    toggle(fiber, val === 'Fiber Certification' || val === 'Copper & Fiber Certification');
    toggle(copper, val === 'Copper Certification' || val === 'Copper & Fiber Certification');
    toggle(fusion, val === 'Fiber Certification' || val === 'Copper & Fiber Certification');
    toggle(copperCords, val === 'Copper Certification' || val === 'Copper & Fiber Certification');
    toggle(ethernetCabling, val === 'Copper Certification' || val === 'Copper & Fiber Certification');

    if (val === 'Copper Certification') {
      copperCertificationDefault.forEach(el => show(el));
      hide(defaultImg);
      show(copperImg);
    } else {
      hide(copperImg);
      show(defaultImg);
    }

    if (val === 'Fiber Certification') {
      hide(defaultImg);
      show(fiberCertificationImgBlock);
      show(fiberDefaultImg);
    } else {
      hide(fiberCertificationImgBlock);
    }

    if (val === 'Copper & Fiber Certification') {
      show(showCopperFiberCerti);
      show(defaultImg);
      hide(fiberDefaultImg);
      show(ethernetCabling);
      show(copperCords);
      show(copperImg);
      hide(fiberCertificationImgBlock);
      hide(showCableYes);


      updateCopperFiberDefaults(); // ✅ run check immediately

    } else {
      hide(showCopperFiberCerti);
      show(fiberDefaultImg);
      hide(defaultImg);
    }

    hide(coaxImg);
    hide(showCables);
  });

  // === FiberTrouble + OpticalLoss change logic ===
  checkFiberTrouble.addEventListener('change', updateCopperFiberDefaults);
  checkOpticalLoss.addEventListener('change', updateCopperFiberDefaults);



  // === Cable Display Logic ===
  function updateCableDisplay() {
    const fiberVal = checkFiberTrouble?.value || '';
    const opticalVal = checkOpticalLoss?.value || '';
    

    toggle(showCables, fiberVal === 'Yes' || opticalVal === 'Yes');

    if (fiberVal === 'Yes' && opticalVal === 'Yes') {
      show(bothConnectorCableYes);
      show(hideConnectorNo);
      show(showCableYes);
      show(showCableYes2);
      hide(fiberDefaultImg);
    } else if (fiberVal === 'Yes' && opticalVal === 'No') {
      hide(showCableYes);
      hide(showCableYes2);
      show(bothConnectorCableYes);
      show(showCableNoAndConnectorYes);
      show(hideConnectorNo);
      hide(fiberDefaultImg);
    } else if (fiberVal === 'No' && opticalVal === 'Yes') {
      show(showCableYes);
      show(showCableYes2);
      show(bothConnectorCableYes);
      hide(showCableNoAndConnectorYes);
      hide(hideConnectorNo);
      hide(fiberDefaultImg);
    } else if (fiberVal === 'No' && opticalVal === 'No') {
      hide(bothConnectorCableYes);
      hide(hideConnectorNo);
      hide(showCableYes);
      hide(showCableYes2);
      hide(showCableNoAndConnectorYes);
      hide(fiberDefaultImg);
    } else {
      hide(bothConnectorCableYes);
      hide(hideConnectorNo);
      hide(showCableYes);
      hide(showCableYes2);
      hide(showCableNoAndConnectorYes);
      show(fiberDefaultImg);
    }
  }

  checkFiberTrouble?.addEventListener('change', updateCableDisplay);
  checkOpticalLoss?.addEventListener('change', updateCableDisplay);

  // === Fusion radios ===
  document.querySelectorAll('.check_fusion_splicing').forEach(radio => {
    radio.addEventListener('change', function () {
      if (this.value === 'Ribbon') {
        show(fusionRibbon);
        hide(fusionSingle);
      } else if (this.value === 'Single Fiber') {
        show(fusionSingle);
        hide(fusionRibbon);
      } else {
        // None selected → hide both
        hide(fusionRibbon);
        hide(fusionSingle);
        hideAllImages();
      }
    });
  });

  // === Fusion items ===
  items.forEach(item => {
    if (!item.checkbox) return;
    item.checkbox.addEventListener('change', function () {
      if (this.checked) {
        hideAllImages();
        this.checked = true;
        show(item.image);
      } else {
        hide(item.image);
      }
    });
  });

  // === Copper radios ===
  checkSpliceCopperRadios.forEach(radio => {
    radio.addEventListener('change', function () {
      toggle(coaxImg, this.value === 'Yes');
    });
  });

  checkPatchCopperRadios.forEach(radio => {
    radio.addEventListener('change', function () {
      if (this.value === 'Yes') {
        show(dsxPc);
      } else {
        hide(dsxPc);
        ['DSX-PC5ES', 'DSX-PC6S', 'DSX-PC6AS'].forEach(id => hide(document.getElementById(id)));
      }
    });
  });

  checkEthernetCablingRadios.forEach(radio => {
    radio.addEventListener('change', function () {
      if (this.value === 'Yes') {
        show(dsxCha);
      } else {
        hide(dsxCha);
        ['DSX-CHA021S', 'DSX-CHA-M12-X-S'].forEach(id => hide(document.getElementById(id)));
      }
    });
  });

  // === DSX toggles ===
  function toggleDSXContent(selectedId, allIds) {
    allIds.forEach(id => {
      const el = document.getElementById(id);
      toggle(el, id === selectedId);
    });
  }

    // === DSX-PC checkboxes (show multiple images) ===
  document.querySelectorAll('.check_dsx-pc').forEach(checkbox => {
    checkbox.addEventListener('change', () => {
      const target = document.getElementById(checkbox.value);
      if (checkbox.checked) {
        show(target);
      } else {
        hide(target);
      }
    });
  });

  // === DSX-CHA checkboxes (show multiple images) ===
  document.querySelectorAll('.DSX-CHA').forEach(checkbox => {
    checkbox.addEventListener('change', () => {
      const target = document.getElementById(checkbox.value);
      if (checkbox.checked) {
        show(target);
      } else {
        hide(target);
      }
    });
  });


});
